export const hourToAMPM = (hour: number) => {
    if(hour === 0) return '12AM';
    if(hour < 12) return `${hour}AM`;
    if(hour === 12) return '12PM';
    return `${hour - 12}PM`;
}